import { projectsService } from '../../../services/service-factory';

export default {
  data: function() {
    return {
      projectsService: undefined
    };
  },
  created: function() {
    this.projectsService = projectsService;
  }
};
